export const Crypto = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#626AFF"/>
    <path d="M23.3819 12.6591C22.4736 10.9039 20.8581 9.52227 18.7987 8.97044C14.9144 7.92966 10.9219 10.2348 9.88112 14.119C8.84034 18.0033 11.1454 21.9958 15.0297 23.0366C17.0891 23.5884 19.179 23.1997 20.8432 22.1337" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M12.8301 24.7655L13.4102 22.6004M17.7578 6.375L17.1785 8.5372" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M16.0723 25.6327L16.6524 23.4676M21 7.24219L20.4206 9.40439" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
);
